import React from 'react';
import { User } from '../../../../types';
import { App } from '../App/App';

interface Props {
  user: User | null;
}

export const SalesForce: React.FC<Props> = ({ user }): JSX.Element => {
  return (
    <App
      title="CRM Integration"
      text="See the effect your authority has on your sales results, focusing on win-rate & sales-cycle length."
      role={user?.role}
    />
  );
};
